import jsonp from 'jsonp'
import { convertParamToString } from './utils'
const SUCCESS_RESULT_CODE = 1

export let request = function (action, params) {
  return new Promise((resolve, reject) => {
    jsonp(action, {
      prefix: 'jsonpCallback',
      param: convertParamToString(params || {})
    }, (err, response) => {
      if (err || SUCCESS_RESULT_CODE !== response.result) {
        const errmsg = response && response.msg && response.msg.replace(/\[-\d*\]/, '')
        resolve({
          errmsg: errmsg,
          data: [],
          res: response
        })
      } else {
        resolve({
          errmsg: '',
          data: response.data,
          res: response
        })
      }
    })
  })
}
